import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const buttonVariants = cva(
    `sph-button relative inline-flex items-center justify-center gap-2.5 whitespace-nowrap text-foreground font-semibold leading-none shadow-sm transition-all duration-[250ms] ease-in-out disabled:pointer-events-none disabled:opacity-50 [&_.sph-icon]:pointer-events-none select-none shrink-0 [&_.item>.sph-icon]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/30 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive`,
    {
        variants: {
            variant: {
                default:
                    "border bg-gray-100 border-gray-300 [&[data-state=open],&.active,&:hover]:text-accent-dark [&[data-state=open],&.active,&:hover]:border-accent/40",
                primary:
                    "bg-primary text-primary-foreground hover:bg-primary/80",
                destructive:
                    "bg-destructive text-white hover:bg-destructive/60 focus-visible:ring-destructive/20",
                ghost: "bg-transparent border border-transparent shadow-none hover:bg-primary hover:text-primary-foreground duration-[350ms]",
                transparent: "border-0 bg-transparent shadow-none focus-visible:ring-[1px]",
            },

            size: {
                "sm": "h-(--button-height-sm) text-sm gap-1.5 px-3 py-1 [&.has-icon]:px-2.5",
                "md": "h-(--button-height-md) text-base px-4 py-2 [&.has-icon]:px-3",
                "icon-sm": "size-(--button-height-sm)",
                "icon-md": "size-(--button-height-md)",
            },

            circle: {
                false: "rounded-md",
                true: "rounded-full",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "md",
            circle: false,
        },
    },
)
export type ButtonVariants = VariantProps<typeof buttonVariants>
